import React from 'react';
import { useDispatch } from 'react-redux';
import { updateShowWelcomeWAMessage } from '../../../../actions/modal';

import Info from '../../info';

export default function RightPanel(props) {
  const dispatch = useDispatch();

  const letsGo = () => {
    dispatch(updateShowWelcomeWAMessage(false));
  };

  return (
    <div>
      <div className="ui actions mrtxxs mrbl max-width hide-on-small-ress">
        <button
          tabIndex="6"
          type="button"
          onClick={letsGo}
          className="ui  labeled icon button icon left-text color-button color-button-hover color-white max-width  mrlnull mrbnull"
        >
          {APP.LANGUAGE.WelcomeWaitingArea.LetsGo}
          <i className="checkmark  icon" />
        </button>
      </div>

      <div className="mrtl hide-on-small-ress">
        <Info paragraphs={[APP.LANGUAGE.WelcomeWaitingArea.HelpHeading]} noIcon={props.isMobile} />
        <div className="ui items mrbs mrtm">
          <div className="item">
            <div className="content ">
              <p className="color-info  platformName">
                {APP.LANGUAGE.WelcomeWaitingArea.HelpHeading1.replace(
                  '##platformName##',
                  window.APP.CONFIGURATION.PORTAL.VideoCallPlatformName
                )}
              </p>
            </div>
            <img className="ui image helpTopAlign" src={window.APP.IMAGES.HelpIconColor.default} />
          </div>
        </div>
        <span className="color-info mrtm">{APP.LANGUAGE.WelcomeWaitingArea.HelpHeading2}</span>
      </div>
      <div className="ui actions mrbl max-width hide-on-tablet-ress hide-on-large-device">
        <button
          tabIndex="6"
          type="button"
          onClick={letsGo}
          className="ui  labeled icon button icon left-text color-button color-button-hover color-white max-width mrtml pdts  mrlnull mrbnull"
        >
          {APP.LANGUAGE.WelcomeWaitingArea.LetsGo}
          <i className="checkmark  icon" />
        </button>
      </div>
    </div>
  );
}
